import { SHGrid } from "@components/design-systems";
import { usePlatformAnalysis } from "@hooks/usePlatformAnalysis";
import { useUserPermissions } from "@hooks/userUserPermission";
import { getProductCardSx } from "@pages/platform-analysis/_id/steps/fee/analysis/components/product-card/util";
import { memo, useMemo } from "react";
import { FeeProductCard } from "@pages/platform-analysis-v2/_id/steps/fee/analysis/components/fee-comment-product-card";

interface FeeAnalysisProductCommentsProps {
  isCompleted?: boolean;
  isReadOnly?: boolean;
}

export const FeeAnalysisProductComments = memo(
  ({
    isCompleted = false,
    isReadOnly = false,
  }: FeeAnalysisProductCommentsProps) => {
    const { isAdviserGroup } = useUserPermissions();
    const { platformAnalysis } = usePlatformAnalysis();

    const selectedProduct = useMemo(() => {
      return platformAnalysis?.fee?.all.selectedProducts ?? [];
    }, [platformAnalysis]);

    return (
      <>
        <SHGrid container width={{ xs: "100%", lg: "250px" }}>
          {selectedProduct.map((product, index) => (
            <SHGrid key={product.id} xs={6} sm={4} md={3} lg={12}>
              <FeeProductCard
                isAdviserView={isAdviserGroup}
                isShowButtons={!isCompleted && !isReadOnly}
                analysisId={platformAnalysis?.id ?? ""}
                product={product}
                sx={getProductCardSx(index)}
              />
            </SHGrid>
          ))}
        </SHGrid>
      </>
    );
  },
);
